import React from 'react'
import CustomForm from './CustomForm'

const Form: React.FC<FormProps> = ({
  form,
  children,
  onSubmit,
  grid = true,
  classes,
  id,
  onKeyDownProp,
  ...props
}) => {
  // Se mapean todos los child, para pasarles a cada componente FormItem el register (handler input de React-hook-form) y tambien los errores,
  // Y se utiliza cloneElement para mantener el ref
  const injectProps = (childrens) => {
    return React.Children.map(childrens, (child) => {
      if (
        child?.props?.children &&
        !child?.props?.name &&
        typeof child?.props?.children !== 'string'
      ) {
        return React.cloneElement(child, {
          ...child.props,
          children: injectProps(child.props?.children),
        })
      }
      return child?.props?.name
        ? React.cloneElement(child, {
            register: form.register,
            errors: form.errors,
            key: child.props.name,
            form,
          })
        : child
    })
  }

  return (
    <CustomForm
      onSubmit={form.handleSubmit(onSubmit)}
      id={id}
      className={`${grid && "grid grid-cols-12"} align-top bg-transparent ${classes}`}
      {...props}
    >
      {injectProps(children)}
    </CustomForm>
  )
}

export default Form

interface FormProps {
  form: any
  children: any
  grid?: boolean
  onSubmit: Function
  classes?: string
  id?: string
  [key: string]: any
  onKeyDownProp?: Function
}
